module.exports = __webpack_public_path__ + "img/brandon_jones.7b9bf34a.png";